import { mcDate } from '@/utils';

export const mcLabels = {
  mealCountTally: {
    available: 'Available',
    served: 'Served',
    leftover: 'Leftover'
  },
  mealCounts: {
    sponsor: 'Sponsor',
    site: 'Site',
    servingDate: 'Serving Date',
    mealType: 'Meal',
    program: 'Program',
    affirmed: 'Affirmed',
    providedDays: 'Number of Days for Non-Congregate',
    receive: {
      receivedTime: 'Meal Received Time',
      receivedTemp: 'Received Temperature',
      receivedMeals: 'Received Meals',
      previousLeftoverMeals: 'Previous Leftover Meals',
      totalMealsAvailable: 'Total Meals Available'
    },
    serve: {
      firstMeals: 'First Meals',
      secondMeals: 'Second Meals',
      adultProgramMeals: 'Adult Program Meals',
      adultNonProgramMeals: 'Adult Non-Program Meals',
      additionalMeals: 'Additional Meals',
      additionalMealsRequested: 'Additional Meals Requested',
      nonCongregateMeals: 'Non-Congregate Meals Served',
      totalMealsServed: 'Total Meals Served'
    },
    waste: {
      mealsWasted: 'Meals Wasted',
      mealsIncomplete: 'Meals Incomplete',
      totalMealsLeftover: 'Total Meals Leftover'
    }
  },
  modalTitles: {
    discard: 'Discard Meal Counts?',
    unsubmitted: 'Count Not Complete!',
    tempCount: 'Data Recovered'
  },
  tempCountText: function (mealTypeId, serviceDate, siteName) {
    return `Meal Counter has recovered unsaved meal count values for ${mealTypeId} on ${mcDate.toShortDate(serviceDate)} for ${siteName}.`;
  }
}
